exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-h1-text[data-v-7290e0f2] {\n  font-size: 30px;\n  font-weight: inherit;\n  color: #eb2020;\n}\n.div-history[data-v-7290e0f2] {\n  min-width: 500px !important;\n}\n.description[data-v-7290e0f2] {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  cursor: pointer;\n}\n", ""]);

// exports
